import script from "./PayDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./PayDetail.vue?vue&type=script&lang=ts&setup=true"

import "./PayDetail.vue?vue&type=style&index=0&id=86a773fc&lang=css"

const __exports__ = script;

export default __exports__